import {
  DiscountType,
  ProductDefinition,
  ProposalProduct,
  ProposalTotals,
} from "../types/proposal";
import { normalizeMoneyValue } from "./currency";

export const buildProposalProducts = (
  products: ProductDefinition[],
): ProposalProduct[] =>
  products.map(product => ({
    ...product,
    selected: false,
    quantity: 1,
    subtotal: 0,
  }));

export const calculateProposal = (
  products: ProposalProduct[],
  freightValue: number,
  discountType: DiscountType,
  discountValue: number,
): { products: ProposalProduct[]; totals: ProposalTotals } => {
  const calculatedProducts = products.map(product => {
    const quantity = Math.max(1, Math.floor(product.quantity || 1));
    return {
      ...product,
      quantity,
      subtotal: product.selected ? product.unitPrice * quantity : 0,
    };
  });
  const subtotal = calculatedProducts.reduce(
    (total, product) => total + product.subtotal,
    0,
  );
  const freight = normalizeMoneyValue(freightValue);
  const amountBeforeDiscount = subtotal + freight;
  const normalizedDiscount = normalizeMoneyValue(discountValue);

  let discount = 0;
  if (discountType === "fixed") {
    discount = Math.min(normalizedDiscount, amountBeforeDiscount);
  }
  if (discountType === "percentage") {
    const percentage = Math.min(normalizedDiscount, 100);
    discount = amountBeforeDiscount * (percentage / 100);
  }

  return {
    products: calculatedProducts,
    totals: {
      subtotal,
      freight,
      discount,
      total: Math.max(0, amountBeforeDiscount - discount),
    },
  };
};
